// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__bT7JI","content":"styles_content__2ygXl","selectAll":"styles_selectAll__2-5y1"};